import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force immediate scroll to top, ignoring CSS scroll-behavior: smooth
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Some browsers might still need this, others use 'auto'
    });
  }, [pathname]);

  return null;
}
